import Btn from '../button/btn/Btn';
import * as css from './PromotionPopup.css';
import MobilePopup from '../newPopup/mobilePopup/MobilePopup';
import {BLACK, mobileMedia, WHITE} from '../../globalVariables/GlobalVariables';
import {btn} from '../button/btn/Btn.css';

export type TButtonProps = {
    onClick: () => void;
    text: string;
    disabled: boolean;
};
export type TShow ={
    open :() => void,
    close: () => void,
    isOpen: boolean,
    showClass: string
}

function PromotionPopup({show, color, image, button, extraButton, children}:{show:TShow, color: string, image:string, button: TButtonProps, extraButton?: React.ReactNode, children: React.ReactNode}){
    const cssStyle = `
        background: ${color};
        height: max-content;
        max-height: calc(100% - 200px);
        width: 440px;
        ${mobileMedia}{
            &.show{
                max-height: 85%;
                height: 85%;
                width: 100%;
                background: ${color};
            }
        }
        ${css.buttonsRow}{
            position: absolute;
            inset-inline: 0;
            inset-block-end: 15px;
        }
        ${btn}{
            background-color:${BLACK};
            color:${WHITE};
            border-color:${BLACK};
            &:hover{
                background-color: ${BLACK};
                border-color: ${BLACK};
            }
            &.white{
                background-color:${WHITE};
                color:${BLACK};
                border-color:${BLACK};
                &:hover{
                    background-color:${WHITE};
                    border-color:${BLACK};
                }
            }
        }
    `;

    return (
        <MobilePopup showClass={show.showClass} close={show.close} dataCyName={'PromotionPopup'} cssStyle={cssStyle} title={undefined} list={undefined} forwardRef={undefined} TopComponent={null}>
            <>
                <css.container image={image}>
                    {children}
                </css.container>
                <css.buttonsRow>
                    {extraButton}
                    <Btn onClick={button.onClick} disabled={button.disabled} className={''}>
                        {button.text}
                    </Btn>
                </css.buttonsRow>
            </>
        </MobilePopup>
    );
}

export default PromotionPopup;
